import { CaseNavigation } from '@/pages/client-portal/ui/case-navigation/case-navigation'
import { CopyLinkButton } from '@/pages/client-portal/ui/copy-link-button/copy-link-button'
import { HeaderWrapper } from '@/pages/client-portal/ui/header-wrapper/header-wrapper'

import { GoogleTranslateWidget } from '@/components/google-translate-widget/google-translate-widget'

import { cn } from '@/lib/utils'

import { useClientPortalPublicHeader } from './use-client-portal-public-header'

export interface ClientPortalHeaderProps {
  caseNumber?: string
}

export const ClientPortalPublicHeader = ({ caseNumber }: ClientPortalHeaderProps) => {
  const {
    currentCaseId,
    copiedUrl,
    dataProUserSelectedCases,
    handleClickCase,
    handleClickPreviousButton,
    handleClickNextButton,
  } = useClientPortalPublicHeader()

  return (
    <>
      <div className={cn('flex items-center space-x-2.5 lg:justify-between', 'mb-4 lg:mb-5')}>
        <GoogleTranslateWidget />
        <CopyLinkButton copiedUrl={copiedUrl} />
      </div>

      {/* Mobile */}
      <HeaderWrapper className={cn('flex flex-col lg:hidden', 'py-[18px]')}>
        <p className={cn('text-[14px] font-medium leading-[14px] text-slate-400', 'h-[14px]')}>Case number</p>
        <p className={cn('text-2xl font-semibold text-primary-foreground', 'h-[32px]', 'mt-2')}>{caseNumber}</p>
        <div className={cn('fixed bottom-0 left-0 right-0 z-[1]', 'px-5 py-[18px]', 'bg-slate-700')}>
          <CaseNavigation
            currentCaseId={currentCaseId}
            proUserSelectedCases={dataProUserSelectedCases}
            onClickCase={handleClickCase}
            onClickPreviousButton={handleClickPreviousButton}
            onClickNextButton={handleClickNextButton}
          />
        </div>
      </HeaderWrapper>

      {/* Desktop */}
      <HeaderWrapper className={cn('py-6')}>
        <p className={cn('text-xl font-normal text-muted-foreground text-slate-400')}>Case number</p>
        <div className={cn('flex items-center', 'mt-3')}>
          <p className={cn('text-[40px] font-extrabold leading-[48px] text-primary-foreground', 'h-[48px]')}>
            {caseNumber ?? '-'}
          </p>
          <div className={cn('ml-auto')}>
            <CaseNavigation
              currentCaseId={currentCaseId}
              proUserSelectedCases={dataProUserSelectedCases}
              onClickCase={handleClickCase}
              onClickPreviousButton={handleClickPreviousButton}
              onClickNextButton={handleClickNextButton}
            />
          </div>
        </div>
      </HeaderWrapper>
    </>
  )
}
